import Ctas from "../components/Ctas";
import Testimonials from "../components/Testimonials";
import { usePageTitle } from "../components/usePageTitle";

export default function About() {
  usePageTitle("About");
  return (
    <>
      <section className="page-head">
        <div className="wrap narrow center">
          <h1 className="display">The space you’re creating</h1>
          <p className="section-title">The community you’re building</p>
        </div>
      </section>

      <section className="band">
        <div className="wrap split">
          <div>
            <p className="lede">
              Off the train tracks, nestled between bustling boutiques, gleaming high-rises and whirring workout centers,
              there’s a sleek building called Platform 18.
            </p>
            <p className="lede">
              <em>That’s us.</em>
            </p>
            <h2 className="section-title">And if you’re a Jewish millennial, that’s your space too.</h2>
          </div>
          <img className="rounded" src="/images/building-night.jpg" alt="Platform 18’s building with its rooftop deck lit up" width="784" height="758" />
        </div>
      </section>

      <section className="band band-tint">
        <div className="wrap narrow center">
          <h2 className="display">
            Insta-worthy relaxation.
            <br />
            <em>Friendship-worthy people.</em>
          </h2>
          <p className="lede">
            Platform 18, a Partners Detroit initiative, is where professionals relax, get work done, and find their niche in
            a community they helped create.
          </p>
        </div>
      </section>

      <section className="band">
        <div className="wrap split">
          <img className="rounded" src="/images/people-coffee.jpg" alt="Two friends talking over coffee at Platform 18" width="1200" height="600" loading="lazy" />
          <div>
            <p className="label">How it all began</p>
            <p>
              It started when we saw you crowding into hot, packed coffee shops down the road, typing furiously on your
              laptop, trying to get things done.
            </p>
            <p>And we thought:</p>
            <p className="lede">
              Wouldn’t it be glorious if you had an insta-worthy place to work, unwind and socialize instead? A place where
              you could meet and connect with Jewish millennial professionals like yourself?
            </p>
          </div>
        </div>
      </section>

      <section className="band band-accent">
        <div className="wrap narrow center">
          <h2 className="display">So Platform 18 was born: your go-to space for all things Jewish, work and social.</h2>
          <p className="lede">
            …or whatever else you want. It’s YOUR space. <em>We’re just the people who run it.</em>
          </p>
          <Ctas light />
        </div>
      </section>

      <Testimonials />
    </>
  );
}
